<template>
  <div>
    <Head :title="`${trip.route.name}`" />
    <h1 class="mb-8 text-2xl font-bold">
      <Link class="text-indigo-400 hover:text-indigo-600" href="/awaits">Лист ожидания</Link>
      <span class="text-indigo-400 font-medium"> / </span>
      <Link class="text-indigo-400 hover:text-indigo-600" :href="`/trips/${trip.id}/edit`">#{{ trip.id }}</Link>
      <span class="text-indigo-400 font-medium"> / </span>
      {{ trip.trip_date }} {{ trip.route.name }} <br/>{{ client.name }} {{ client.phone }}
    </h1>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden mt-8 mb-8">
      <div class="flex flex-wrap -mb-8 -mr-6 p-8">
        <div class="mb-2 w-full">
          <strong>Дата: </strong>{{ trip.day }} {{ trip.hour }}:{{ trip.minute }}
        </div>
        <div class="mb-8 w-full">
          <strong>Статус: </strong> {{ trip.status_name }}
        </div>
        <div class="mb-8 w-full">
          <strong>Маршрут: </strong> <Link class="text-indigo-400 hover:text-indigo-600" :href="`/routes/${trip.route.id}`">{{ trip.route.name }}</Link>
        </div>
        <div class="mb-8 w-full">
          <strong>Базовая цена поездки: </strong> {{ trip.price }}
        </div>
        <div class="mb-8 w-full">
          <strong>Мест доступно: </strong> {{ trip.available_seats }}
        </div>
        <div class="mb-8 w-full">
          <strong>Мессенджеры, которые использует клиент:</strong>
          <Messengers :client="client" />
        </div>
        <div class="mb-8 w-full">
          <strong>Добавлен: </strong> {{ client.pivot.added_by }} {{ new Date(client.pivot.created_at).toLocaleString('ru-RU') }}
        </div>
      </div>
    </div>
    <h1 class="mb-8 mt-5 text-2xl font-bold">
      Данные по поездке
    </h1>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden mt-8 mb-8">
      <form>
        <div class="flex flex-wrap flex-lg-nowrap -mb-8 -mr-6 p-8">
          <Link class="text-indigo-400 hover:text-indigo-600 mb-4" :href="`/clients/${client.id}/edit`">
            {{ client.name }} {{ client.phone }} {{ client.stats }}
          </Link>
          <select-input disabled="disabled" v-model="form.point_id" :error="form.errors.point_id" class="pb-8 pr-6" label="Точка">
            <option :value="null" />
            <option v-for="point in points" :key="point.id" :value="point.id" :selected="form.point_id === point.id">{{ point.pivot.time_to }} мин {{ point.name }} </option>
          </select-input>
          <select-input disabled="disabled" v-model="form.seats" :error="form.errors.seats" class="pb-8 pr-6" label="Мест">
            <option value="1" :selected="form.seats === 1">1</option>
            <option value="2" :selected="form.seats === 2">2</option>
            <option value="3" :selected="form.seats === 3">3</option>
            <option value="4" :selected="form.seats === 4">4</option>
            <option value="5" :selected="form.seats === 5">5</option>
            <option value="6" :selected="form.seats === 6">6</option>
          </select-input>
          <textarea-input disabled="disabled" v-model="form.comment" :error="form.errors.comment" class="pb-8 pr-6 w-full" label="Комментарии (видны всем)" />
        </div>
      </form>
      <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
        <button class="text-danger-600 hover:underline" tabindex="-1" type="button" @click="removeAwait">Удалить из листа ожидания</button>
        <button tabindex="-1" type="button" class="btn-indigo ml-auto" @click="requestConfirm">Предложить место в этой поездке</button>
      </div>
    </div>
    <h1 class="mb-8 mt-5 text-2xl font-bold">
      Перемещение в поездку
    </h1>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden mt-8 mb-8">
      <form @submit.prevent="move">
        <div class="flex flex-wrap flex-lg-nowrap -mb-8 -mr-6 p-8">
          <text-input v-model="moveForm.trip_id" :error="moveForm.errors.trip_id" class="pb-8 pr-6" label="ID поездки для перемещения" />
        </div>
        <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="moveForm.processing" class="btn-indigo ml-auto" type="submit">Переместить</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TextareaInput from '@/Shared/TextareaInput'
import Messengers from '@/Shared/Messengers.vue'

export default {
  components: {
    Messengers,
    TextareaInput,
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
  },
  layout: Layout,
  props: {
    trip: Object,
    client: Object,
    points: Array,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        point_id: this.client.pivot.point_id,
        price: this.client.pivot.price,
        comment: this.client.pivot.comment,
        paid: this.client.pivot.paid,
        seats: this.client.pivot.seats,
        address: this.client.pivot.address,
      }),
      moveForm: this.$inertia.form({
        trip_id: this.client.pivot.trip_id,
      }),
    }
  },
  methods: {
    move() {
      this.moveForm.put(`/trips/${this.trip.id}/awaits/${this.client.id}/move`)
    },
    removeAwait() {
      this.$inertia.get(`/trips/${this.trip.id}/awaits/${this.client.id}/remove`)
    },
    requestConfirm() {
      this.$inertia.get(`/trips/${this.trip.id}/awaits/${this.client.id}/request`)
    },
  },
}
</script>
